import SnapSection from './SnapSection'

export default SnapSection;